<script setup>
import { useLocalePath } from '#imports'
import User from './icons/User.vue'
import Download from './icons/Download.vue'
import Language from './icons/Language.vue'
// import Notification from './icons/Notification.vue'
import NavList from './NavList.vue'
import { useDownloadDropOptions, useLanguageDropOptions, useUserDropOptions } from './hooks'
// import { spotOrigin } from '~/utils'
import { useUserStore } from '~/store/user'
import { useWindowSize } from '@vueuse/core'
import Menu from './icons/Menu.vue'
import { useNav } from '../footer/config'
import MenuDrawer from './MenuDrawer.vue'

const { width } = useWindowSize()

const { t } = useI18n()
const localePath = useLocalePath()
const user = useUserStore()
const lauguageOptions = useLanguageDropOptions()
const navList = useNav({ t, localePath })

const showDrawer = ref(false)

const list = computed(() => {
  if (width.value < 768) {
    return []
  }
  return [
    { icon: Download, key: 'Download', options: useDownloadDropOptions() },
    { icon: Language, key: 'Language', options: lauguageOptions },
  ]
})

function handleClick() {
  showDrawer.value = true
}
</script>

<template>
  <div class="flex items-center space-x-2 rtl:space-x-reverse">
    <ClientOnly>
      <template v-if="user.isLogin">
        <NavList class-name="h-10 !w-10 !px-2 text-textPrimary max-md:hidden" :icon="User" :options="useUserDropOptions()" />
        <!-- <NavList class-name="h-10 !w-10 !px-2" :icon="Notification" :href="`${spotOrigin}/#/inform`" /> -->
      </template>
      <NavList
        v-for="i in list"
        :key="i.key"
        :icon="i.icon"
        v-bind="i"
        class-name="h-10 !w-10 !px-2 text-textPrimary"
      />

      <component :is="Menu" class="hidden w-6 h-6 max-md:block" @click="handleClick()" />
      <MenuDrawer :show="showDrawer" :menu-list="navList" @update:show="showDrawer = $event" />
    </ClientOnly>
  </div>
</template>
